module.exports = __webpack_public_path__ + "assets/img/icon-01.04de92b3.png";